import Editor from './editor';

/**
 * Interface extending HTMLElement to include custom properties for event listeners and range.
 */
interface ExtendedHTMLElement extends HTMLElement {
  inputListener?: EventListenerOrEventListenerObject;
  keydownListener?: EventListenerOrEventListenerObject;
  clickListener?: EventListenerOrEventListenerObject;
  pasteListener?: EventListenerOrEventListenerObject;
  selectionChangeListener?: EventListenerOrEventListenerObject;
  range?: Range;
}

/**
 * Class representing an HTML editor with various functionalities.
 */
export default class MarkdownEditor extends Editor {

  /**
   * Executes a command on the reference element.
   * @param ref - The HTML element reference.
   * @param name - The command name.
   * @param value - The command value.
   * @returns The result of queryCommands.
   */
  execCommand(ref: ExtendedHTMLElement, name: string, value: string): any {
    console.log('execCommand', name, value);
    if (document.activeElement != ref && ref) {
      ref.focus();
    }

    const selection = getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const selectedText = range.toString();

      let formattedText = '';
      switch (name) {
        case 'bold':
          formattedText = `**${selectedText}**`;
          break;
        case 'italic':
          formattedText = `*${selectedText}*`;
          break;
        case 'heading':
          formattedText = `# ${selectedText}`;
          break;
        // Add more cases for other commands
        default:
          document.execCommand(name, false, value);
          return this.queryCommands(ref);
      }

      // Replace the selected text with the formatted text
      range.deleteContents();
      range.insertNode(document.createTextNode(formattedText));
    } else {
      switch (name) {
        case 'bold':
          document.execCommand('insertText', false, '**bold**');
          break;
        case 'italic':
          document.execCommand('insertText', false, '*italic*');
          break;
        case 'heading':
          document.execCommand('insertText', false, '# Heading');
          break;
        // Add more cases for other commands
        default:
          document.execCommand(name, false, value);
      }

      return this.queryCommands(ref);
    }
  }

  /**
   * Queries the commands state of the reference element.
   * @param ref - The HTML element reference.
   * @returns An object containing the command states.
   */
  queryCommands(ref: ExtendedHTMLElement): any {
    var q = {
      content: ref != null ? ref.innerHTML : null,
      bold: document.queryCommandState('bold'),
      underline: document.queryCommandState('underline'),
      italic: document.queryCommandState('italic'),
      strikeThrough: document.queryCommandState('strikeThrough'),
      unlink: document.queryCommandEnabled('unlink'),
      undo: document.queryCommandEnabled('undo'),
      redo: document.queryCommandEnabled('redo')
    };
    console.log('queryCommands', q);
    return q;
  }
}

